import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import React, { SyntheticEvent } from "react";
import { useBranchDepartmentFilters } from "../../../reusableComponents/dashboardFilters/dashboardFilters";

/**
 * ── LEGACY SHELL — SCHEDULED FOR DELETION ──────────────────────────────────
 *
 * The branch/department selects as dashboardHeader.tsx drew them: full-width
 * FormControls at MUI's default size, sharing a 4-column slot. The shared
 * <DashboardFilters> uses size="small" at a fixed 190px, which is the refresh
 * and reads noticeably smaller.
 *
 * Only the markup is duplicated — the loading and option ordering come from the
 * shared hook, so there is one copy of the behaviour.
 */
const LegacyFilters = () => {
  const {
    selectedBranch,
    selectedDepartment,
    branchOptions,
    departmentOptions,
    handleBranchChange,
    handleDepartmentChange
  } = useBranchDepartmentFilters();

  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: 2, width: "100%" }}>
      <FormControl fullWidth>
        <Autocomplete
          id="branch"
          value={selectedBranch}
          onChange={(_: SyntheticEvent, newValue: string | null) => handleBranchChange(newValue)}
          options={branchOptions}
          isOptionEqualToValue={(option: any, newValue: any) => option.id === newValue.id}
          renderInput={(params) => <TextField {...params} label="Branches" placeholder="Branches" />}
        />
      </FormControl>
      <FormControl fullWidth>
        <Autocomplete
          id="department"
          value={selectedDepartment}
          onChange={(_: SyntheticEvent, newValue: string | null) =>
            handleDepartmentChange(newValue)
          }
          options={departmentOptions}
          isOptionEqualToValue={(option: any, newValue: any) => option.id === newValue.id}
          renderInput={(params) => (
            <TextField {...params} label="Departments" placeholder="Departments" />
          )}
        />
      </FormControl>
    </Box>
  );
};

export default LegacyFilters;
